export default __webpack_public_path__ + "static/media/279.c20ef719.png";